import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';

export class ClickableAttribute extends AbstractBlock {
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    // let str =   "  class = 'clickable' "  + attribute ;
    const str = CodeSetting.buildAttribute([['class', 'clickable']], attribute);

    return [str];
  }
}
